<div [ngClass]="{'open': !(isNavBarCollapsed | async)}">
  <ds-themed-header></ds-themed-header>
</div>
